export {default as MediaPreview} from './MediaPreview';



// WEBPACK FOOTER //
// ./src/components/mediaPreview/index.js